import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import s from "./Drawer.module.css";
import HabitsPanel from "./HabitsPanel.js";
import FoodPanel from "./FoodPanel.js";
import WaterPanel from "./WaterPanel.js";
const TABS = ["habits", "food", "water"];
export default function Drawer({ isOpen, tab, onTabChange, onClose, habits, onToggleHabit, onCreateHabit, food, targets, onAddFood, onDeleteFood, onUpdateFood, water, onSetWater, plusBtnRef, }) {
    const drawerRef = useRef(null);
    useEffect(() => {
        if (!isOpen)
            return;
        const handler = (e) => {
            if (drawerRef.current &&
                !drawerRef.current.contains(e.target) &&
                plusBtnRef.current &&
                !plusBtnRef.current.contains(e.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [isOpen, onClose, plusBtnRef]);
    return (_jsxs("div", { ref: drawerRef, className: `${s.drawer}${isOpen ? ` ${s.drawerOpen}` : ""}`, children: [_jsx("div", { className: s.dtabs, children: TABS.map((t) => (_jsx("div", { className: `${s.dtab}${tab === t ? ` ${s.dtabActive}` : ""}`, onClick: () => onTabChange(t), children: t.charAt(0).toUpperCase() + t.slice(1) }, t))) }), tab === "habits" && (_jsx(HabitsPanel, { habits: habits, onToggle: onToggleHabit, onCreateHabit: onCreateHabit })), tab === "food" && (_jsx(FoodPanel, { entries: food?.entries ?? [], targets: targets, onAdd: onAddFood, onDelete: onDeleteFood, onUpdate: onUpdateFood })), tab === "water" && (_jsx(WaterPanel, { glasses: water?.glasses ?? 0, target: 8, onSet: onSetWater }))] }));
}
//# sourceMappingURL=Drawer.js.map